'use strict'

/*
    Action:     Config for the standings table
    Original:   /tea/core-tea/redesign/src/main/tea/api/v0/modules/standings/config.tea
    Orginator:  ben.hobden@espn.com
*/

var StandingConfig = {

  get: function (oRequest = {}) {

    if ( Object.prototype.toString.call(oRequest) !== '[object Object]' || Object.keys(oRequest).length === 0 ) {
      return {}
    }

    /* default the objects values */
    let oConfig = {
      'views' :       [],
      'groups' :      [],
      'links' :       [],
      'categories' :  [],
      'parameters':   {
        'view' :        '',
        'group' :       '',
        'sort' :        '',
        'dir' :         '',
        'season' :      false,
        'seasontype' :  1
      },
      'type' :        false,
      'groupType' :   false,
      'playoffCutoff' : 1000,
      'showPlayoffSeed' : 0,
      'showPlayoffSeedSubscript' : 0,
      'showSeasonDropdown' : true,
      'showLeagueDropdown' : false,
      'useDisplayName' : 1,
      'teamPosition' : 0,
      'mergeTable' :  false,
      'splitSeason' : false,        // sets the format of the season from 2015 to 2014/15
      'shiftSeasonForward' :false,  // when used with splitSeason will set the date from 2015 to 2015/16
      'highlightQualified' : false
    }
    let oCategoryMap = {}
    let oDefaultSortDirections = {}
    let i = 0
    let defaults = {
      'view' :      'standings',
      'group' :     '',
      'sort' :      'rank',
      'dir' :       'asc',
      'season' :    false,
      'seasontype' :1
    }

    /* individual config could this be abstracted elswehere or passed in? */
    if(oRequest.sport == 'soccer') {

      oConfig.type                = 0
      oConfig.teamPosition        = 0
      oConfig.splitSeason         = true
      oConfig.shiftSeasonForward  = true
      oConfig.showLeagueDropdown  = true
      oConfig.showSeasonDropdown  = true
      oConfig.mergeTable          = true

      oCategoryMap = {
        'standings':[
          { key:'gamesplayed', colgroup:2, sortable:1 },
          { key:'wins', colgroup:2, sortable:1 },
          { key:'ties', colgroup:2, sortable:1 },
          { key:'losses', colgroup:2, sortable:1 },
          { key:'pointsfor', colgroup:2, sortable:1 },
          { key:'pointsagainst', colgroup:2, sortable:1 },
          { key:'pointdifferential', colgroup:3, sortable:1, colorize:true },
          { key:'points', colgroup:4, sortable:1 }
        ]
      }

      oDefaultSortDirections = {
        'rank':'asc',
        'gamesplayed':'desc',
        'wins':'desc',
        'ties':'desc',
        'losses':'asc',
        'pointsfor':'desc',
        'pointsagainst':'asc',
        'pointdifferential':'desc',
        'points':'desc'
      }

    }else if(oRequest.sport == 'cricket') {

      oConfig.type                = 0
      oConfig.teamPosition        = 0
      oConfig.splitSeason         = true
      oConfig.shiftSeasonForward  = true
      oConfig.showLeagueDropdown  = true
      oConfig.showSeasonDropdown  = true
      oConfig.highlightQualified  = true
      oCategoryMap = {
        'standings':[
          { key:'matchesplayed',colgroup:2, sortable:1 },
          { key:'matcheswon',colgroup:2, sortable:1 },
          { key:'matcheslost',colgroup:2, sortable:1 },
          { key:'matchestied',colgroup:2, sortable:1 },
          { key:'matchesdraw',colgroup:2, sortable:1 },
          { key:'noresult',colgroup:2, sortable:1 },
          { key:'matchpoints',colgroup:2, sortable:1 },
          { key:'quotient',colgroup:2, sortable:1 },
          { key:'nrr',colgroup:3, sortable:1 },
          { key:'for',colgroup:3, sortable:1 },
          { key:'against',colgroup:3, sortable:1 }
        ]
      }

    }else if(oRequest.sport == 'rugby') {

      oConfig.type                = 0
      oConfig.teamPosition        = 0
      oConfig.splitSeason         = true
      oConfig.shiftSeasonForward  = true
      oConfig.showLeagueDropdown  = true
      oConfig.showSeasonDropdown  = true
      oConfig.mergeTable          = true

      oCategoryMap = {
        'standings':[
          { key:'gamesplayed', colgroup:2, sortable:1 },
          { key:'gameswon', colgroup:2, sortable:1 },
          { key:'gamesdrawn', colgroup:2, sortable:1 },
          { key:'gameslost', colgroup:2, sortable:1 },
          { key:'gamesbye', colgroup:2, sortable:0 },
          { key:'pointsfor', colgroup:2, sortable:1 },
          { key:'pointsagainst', colgroup:2, sortable:1 },
          { key:'triesfor', colgroup:2, sortable:1 },
          { key:'triesagainst', colgroup:2, sortable:1 },
          { key:'bonuspointstry', colgroup:2, sortable:1 },
          { key:'bonuspointslosing', colgroup:2, sortable:1 },
          { key:'bonuspoints', colgroup:2, sortable:1 },
          { key:'pointsdifference', colgroup:3, sortable:1, colorize:true },
          { key:'points', colgroup:4, sortable:1 }
        ]
      }

      oDefaultSortDirections = {
        rank :          'asc',
        gamesplayed :   'desc',
        gameswon :      'desc',
        gamesdrawn :    'desc',
        gameslost :     'asc',
        pointsfor :     'desc',
        pointsagainst : 'asc',
        triesfor :     'desc',
        triesagainst : 'asc',
        bonuspointstry :'desc',
        bonuspointslosing : 'desc',
        bonuspoints :   'desc',
        pointsdifference :  'desc',
        points :        'desc'
      }

    }else if(oRequest.sport == 'rugby-league') {

      oConfig.type                = 0
      oConfig.teamPosition        = 0
      oConfig.splitSeason         = true
      oConfig.shiftSeasonForward  = true
      oConfig.showLeagueDropdown  = true
      oConfig.showSeasonDropdown  = true
      oConfig.mergeTable          = true

      oCategoryMap = {
        'standings':[
          { key:'gamesplayed', colgroup:2, sortable:1 },
          { key:'gameswon', colgroup:2, sortable:1 },
          { key:'gamesdrawn', colgroup:2, sortable:1 },
          { key:'gameslost', colgroup:2, sortable:1 },
          { key:'gamesbye', colgroup:2, sortable:0 },
          { key:'pointsfor', colgroup:2, sortable:1 },
          { key:'pointsagainst', colgroup:2, sortable:1 },
          { key:'triesfor', colgroup:2, sortable:1 },
          { key:'triesagainst', colgroup:2, sortable:1 },
          //{ key:'bonuspointstry', colgroup:2, sortable:1 },
          //{ key:'bonuspointslosing', colgroup:2, sortable:1 },
          //{ key:'bonuspoints', colgroup:2, sortable:1 },
          { key:'pointsdifference', colgroup:3, sortable:1, colorize:true },
          { key:'points', colgroup:4, sortable:1 }
        ]
      }

      oDefaultSortDirections = {
        rank :          'asc',
        gamesplayed :   'desc',
        gameswon :      'desc',
        gamesdrawn :    'desc',
        gameslost :     'asc',
        pointsfor :     'desc',
        pointsagainst : 'asc',
        triesfor :     'desc',
        triesagainst : 'asc',
        //bonuspointstry :'desc',
        //bonuspointslosing : 'desc',
        //bonuspoints :   'desc',
        pointsdifference :  'desc',
        points :        'desc'
      }

    }else{
      return {}
    }

    /* check params for view if found and valid mark as active else default */
    var sParamView = oRequest.params.view || '',
      bViewFound = 0

    for (i = 0; i < oConfig.views.length; ++i) {
      if(oConfig.views[i].key === sParamView) {
        bViewFound = 1
        oConfig.parameters.view = sParamView
      }
    }
    if(!bViewFound) {
      oConfig.parameters.view = defaults.view
    }

    for (i = 0; i < oConfig.views.length; ++i) {
      if(oConfig.views[i].key === oConfig.parameters.view) {
        oConfig.views[i].active = 1
        oConfig.type = oConfig.views[i].type /* set the type here */
      }
    }

    /* check params for group if found and valid mark as active else default */
    var sParamGroup = oRequest.params.group || '',
      bGroupFound = 0

    for (i = 0; i < oConfig.groups.length; ++i) {
      if(oConfig.groups[i].key === sParamGroup) {
        bGroupFound = 1
        oConfig.parameters.group = sParamGroup
      }
    }
    if(!bGroupFound) {
      oConfig.parameters.group = defaults.group
    }
    for (i = 0; i < oConfig.groups.length; ++i) {
      if(oConfig.groups[i].key === oConfig.parameters.group) {
        oConfig.groups[i].active = 1
        oConfig.groupType = oConfig.groups[i].type /* set the group type here */
      }
    }

    /* set the category map. */
    oConfig.categories = oCategoryMap[oConfig.parameters.view] || []

    /* check params for sort and make sure you are allowed to sort */
    //const calLen  = oConfig.categories.length
    let sParamSort  = oRequest.params.sortKey || ''
    let sParamDir   = oRequest.params.sortDir || ''
    let bSortFound  = 0

    /* check its valid else nerf it */
    if(sParamDir !== 'asc' && sParamDir !== 'desc') {
      sParamDir = ''
    }

    /* find the sort direction and make sure it is ok. */
    for (i = 0; i < oConfig.categories.length; ++i) {
      if(oConfig.categories[i].key === sParamSort && typeof oConfig.categories[i].sortable !== 'undefined' && oConfig.categories[i].sortable) {
        bSortFound = 1
        oConfig.parameters.sort = sParamSort

        /* get this sorts default direction */
        var sDefaultDir = defaults.dir
        if(typeof oDefaultSortDirections[oConfig.parameters.sort] !== 'undefined') {
          sDefaultDir = oDefaultSortDirections[oConfig.parameters.sort]
          defaults.dir = sDefaultDir
        }

        if(!sParamDir) {
          oConfig.parameters.dir = sDefaultDir
        }else{
          oConfig.parameters.dir = sParamDir
        }
      }
    }
    if(!bSortFound) {
      oConfig.parameters.sort = defaults.sort
      oConfig.parameters.dir  = defaults.dir
    }


    /* TODO: do data validation on year na type */
    oConfig.parameters.season     = oRequest.params.season || defaults.season
    oConfig.parameters.seasontype   = oRequest.params.seasontype || defaults.seasontype

    /* Now some of the data has been determined further config can be made. */
    if(oRequest.league == 'nfl') {

      oConfig.metaTitle               = 'NFL Regular Season Standings'

      if(oConfig.parameters.seasontype == 'pre') {
        oConfig.metaTitle = 'NFL Preseason Standings'
        oConfig.subHeader = oConfig.metaTitle
        oConfig.views = {}
        oConfig.groups = {}
      }

      if(oConfig.parameters.group == 'conference') {
        oConfig.mergeTable          = true
      }

      if(oConfig.parameters.view == 'playoff') {

        oConfig.type                = 1 // view
        oConfig.groupType           = 2 // group
        oConfig.metaTitle           = 'NFL Playoff Standings'
        oConfig.subHeader           = 'NFL Playoff Standings'
        oConfig.groups              = {}
        oConfig.parameters.group    = 'conference'
        oConfig.showPlayoffSeed     = true
        oConfig.showSeasonDropdown  = false

        /* no sorting here! */
        oConfig.parameters.sort     = 'conferencerank'
        oConfig.parameters.dir      = 'asc'

      } else if(oConfig.parameters.view == 'expanded') {
        oConfig.showSeasonDropdown  = false
        oConfig.subHeader           = 'NFL Expanded Standings'
      } else if(oConfig.parameters.view == 'vs-division') {
        oConfig.showSeasonDropdown  = false
        oConfig.subHeader           = 'NFL Division Standings'
      }

      oConfig.metaTitle = oConfig.seasonDisplay & ' ' & oConfig.metaTitle & ' - National Football League'

    }else if(oRequest.sport == 'soccer') {

      /* switches on the rank next to the team */
      if(oConfig.parameters.sort === defaults.sort) {
        oConfig.showPlayoffSeed = 1
      }

      /* for some reason? */
      if(oRequest.params.league === 'usa.1') {
        oConfig.splitSeason = false
      }

    } else if(oRequest.sport == 'rugby' || oRequest.sport == 'rugby-league' || oRequest.sport == 'cricket') {

      /* switches on the rank next to the team */
      if(oConfig.parameters.sort === defaults.sort) {
        oConfig.showPlayoffSeed = 1
      }

    }

    return oConfig
  }

}

export default StandingConfig



// WEBPACK FOOTER //
// ../app/components/standings/config.js